import { Component, OnInit, Input } from '@angular/core';
import { IHoliday } from '@signal/asp-data-commons';

@Component({
  selector: 'app-holidays-list',
  templateUrl: './holidays-list.component.html',
  styleUrls: ['./holidays-list.component.scss']
})
export class HolidaysListComponent implements OnInit {
  @Input() holidays:IHoliday[]
  constructor() { }

  ngOnInit() {
  }

}
